import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import { api } from "@/api";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";

const Admin = () => {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, []);

  return (
    <div className="min-h-screen bg-cream px-6 pb-20 pt-32" data-testid="admin-page">
      <Seo title="Administration — Alexis Peinture" description="Espace d'administration du site Alexis Peinture." />
      <div className="mx-auto max-w-6xl">
        {user === undefined ? (
          <p className="text-center text-bark">Chargement…</p>
        ) : user ? (
          <AdminDashboard user={user} onLogout={() => setUser(null)} />
        ) : (
          <AdminLogin onLogin={setUser} />
        )}
      </div>
    </div>
  );
};

export default Admin;
